import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListGroup } from "react-bootstrap";

const getLabel = (value) => String(value);
const getValue = (value) => value

const SelectList = React.forwardRef(({ 
    options = [], 
    nullable = false, 
    loading = false,
    selected = null, 
    parseLabel = getLabel, 
    parseValue = getValue, 
    onSelect, 
    nullLabel = "Remover seleção", 
    emptyLabel = "Sem opções",
    loadingLabel = "Carregando...",
    ...rest 
}, ref) => {

    return (
        <ListGroup {...rest}>
            { loading ? 
                <ListGroup.Item className="text-muted text-center" onClick={() => onSelect(null)}>
                    <FontAwesomeIcon icon="cog" spin/> {loadingLabel}
                </ListGroup.Item>
                :
                <>
                { (nullable && selected) &&
                    <ListGroup.Item action className="text-muted text-center" onClick={() => onSelect(null)}>
                        <FontAwesomeIcon icon="times"/> {nullLabel}
                    </ListGroup.Item>
                }
                {   
                    options.length === 0 ?
                    <ListGroup.Item className="text-muted text-center">
                        {emptyLabel}
                    </ListGroup.Item>
                    : options.map((option, i) => (
                        <ListGroup.Item key={i} action
                            active={selected === parseValue(option)} 
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={(e) => onSelect(option, e)}>
                            {parseLabel(option)}
                        </ListGroup.Item>
                    ))
                }
                </>
            }
        </ListGroup>
    )
});

export default SelectList;